import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import CustomButton from '@components/Button/Button';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { IMaskInput } from 'react-imask';
import { useDispatch } from 'react-redux';
import { setCustomAlert } from '@redux/actions/general';

const CounterWrapper = styled('div')`
  display: flex;
  items: center;
  .min-btn {
    min-width: 0px !important;
    padding: 0px;
    width: 30px;
    height: 44px;
    border-radius: 5px 0px 0px 5px;
  }
  .add-btn {
    min-width: 0px !important;
    padding: 0px;
    width: 30px;
    height: 44px;
    border-radius: 0px 5px 5px 0px;
  }
  .Mui-disabled {
    opacity: 0.5;
  }
`;
export default function Counter({ count, setCount, additionalValues }) {
  const { min, total, availableSeat, noOfSeats } = additionalValues;
  const ref = useRef(null);
  const dispatch = useDispatch();
  const handleDecrement = () => {
    // const value = Number(count) - total - 1;
    // value + availableSeat < availableSeat
    if (
      (!noOfSeats?.type || noOfSeats?.type === 'subtract') &&
      noOfSeats?.seats >= availableSeat
    ) {
      dispatch(
        setCustomAlert({
          message:
            'The number of seat(s) you’re removing exceeds your available seat(s). Remove team members or update the seat number to proceed.',
          state: true,
          type: 'info',
          position: 'bottom-center',
        })
      );
      return;
    }
    setCount((prev) => (Number(prev) - 1).toString());
  };
  const handleIncrement = () => {
    setCount((prev) => (Number(prev) + 1).toString());
  };
  return (
    <CounterWrapper>
      <CustomButton
        onClick={handleDecrement}
        className='min-btn'
        btnColor='blue'
        disabled={
          (noOfSeats?.type === 'subtract' &&
            noOfSeats?.seats > availableSeat) ||
          count <= min ||
          [''].includes(count)
        }
      >
        <RemoveIcon />
      </CustomButton>
      <IMaskInput
        mask={Number}
        value={count}
        ref={ref}
        onAccept={(value) => {
          if (value) {
            setCount(value);
          }
        }}
        maxLength='4'
        max='1000'
        min={min?.toString() || '0'}
        className='text-center w-[50px] h-[44px] bg-custom-bgGrey text-secondary-blue font-semibold text-sm flex items-center justify-center'
      />
      <CustomButton
        onClick={handleIncrement}
        className='add-btn'
        btnColor='blue'
      >
        <AddIcon />
      </CustomButton>
    </CounterWrapper>
  );
}
Counter.propTypes = {
  count: PropTypes.string,
  min: PropTypes.string,
  setCount: PropTypes.func,
  additionalValues: PropTypes.object,
};
